export default "__VITE_ASSET__DsXsnWKp__"